import { render, staticRenderFns } from "./ManagementDashboard.vue?vue&type=template&id=2c1922de"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js"
import style0 from "./ManagementDashboard.vue?vue&type=style&index=0&id=2c1922de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports